import { render, staticRenderFns } from "./NoAppointmentsAvailable.vue?vue&type=template&id=23805d90"
import script from "./NoAppointmentsAvailable.vue?vue&type=script&lang=js"
export * from "./NoAppointmentsAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports